module.exports = __webpack_public_path__ + "78812f96b0b712646276f8e3faa6d47f.MP3";